import {Admin} from "../model/admin";
import {Customer} from "../model/customer";
import {Logistic} from "../model/logistic";
import {Researcher} from "../model/researcher";
import {Tester} from "../model/tester";
import {BehaviorSubject, Observable} from "rxjs";


export type InternalUser = Admin | Customer | Logistic | Researcher | Tester;

export abstract class AuthService {
  redirectUrl: string = '/reserved';
  protected _internalUser?: InternalUser;
  protected behaviorUser: BehaviorSubject<InternalUser | undefined> = new BehaviorSubject<InternalUser | undefined>(undefined);

  abstract login(): void;
  abstract logout(): void;
  abstract refreshUser?(): void;
  abstract changePassword(oldPass: string, newPass: string): Observable<void>;
  abstract clearUser?(): void;
  abstract getToken(): Observable<string>;

  public loggedUser(): InternalUser | undefined {
    return this._internalUser;
  }

  public onUserChange(): Observable<InternalUser | undefined> {
    return this.behaviorUser.asObservable();
  }

}
